// extracted by mini-css-extract-plugin
module.exports = {"container":"FooterListItem_container__j1cSf"};